import { ChangeDetectionStrategy, Component, Input, ViewChild,Output, ChangeDetectorRef,EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';

import { MenuItem, SelectItem, MessageService ,SortEvent} from "primeng/api";
import { Table } from 'primeng/table';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { CatDirecciones, ConsultaOrdenesTrabajo, EtapasOrdenes } from '../../entidades/entidades'
import { CatDireccionesService } from '../../servicios/cat-direcciones.service';
import { CatEstatusService } from '../../servicios/cat-estatus.service';
import { CatUsuariosService } from '../../servicios/cat-usuarios.service';



@Component({
    selector: 'app-ordenes-trabajo-flujo',
    templateUrl: "./ordenes-trabajo-flujo.component.html",
    styleUrls: ["./ordenes-trabajo-flujo.component.css"],
    providers: [MessageService],
})
export class OrdenesTrabajoFlujoComponent { 
    //Entidad principal
    public etapasOrdenes:  EtapasOrdenes[] =[]; 
    public etapasOdenesClone: EtapasOrdenes[] =[];

     //Elementos tabla
    public FlujoOrdenForm: FormGroup;
    public itemsMenu: MenuItem[];
    public columnasTabla: any[];
    public loading: boolean;

    //generales
    public catDireccionesAll: SelectItem[];
    public catDireccionesAreas: SelectItem[];
    public CatDireccionesDto: SelectItem[];
    public CatDireccionesOfi: SelectItem[];
    public CatUsuaruis: SelectItem[];
    public estatus: SelectItem[];
    public estatusFiltrado: SelectItem[];
    public catUsuarios: any[];
    public muestraMensaje = new MuestraMensaje();
    
    @Input() etapasOrdenesInput: EtapasOrdenes[];
    @Input("esEstadoCuenta")   esEstadoCuenta: boolean = false;
    @Input() consultaOrdenInput: ConsultaOrdenesTrabajo;
    @Output() eventRefreschEmit: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();

    @ViewChild('dtEtapasOrdenes') dtEtapasOrdenes : Table;

    
 
    constructor(
        private formBuilder: FormBuilder,
        private catDireccionesService: CatDireccionesService,
        private catEstatusService : CatEstatusService,
        private catUsuariosService: CatUsuariosService,
        private messageService: MessageService,
        private changeDetectorRef: ChangeDetectorRef,
      ) {}

      //evento al inicializar componenet
      async ngOnInit():Promise<void> {
        
        await this.getAllCatUsuarios();
        await this.catDireccionesGet();
        await this.getcatEstatus();
        await this.getcatEstatusFiltrado();

        this.itemsMenu = [
          { label: "Agregar", icon: "pi pi-plus", command: () => this.add(), },
          //{ label: "", icon: "pi pi-save", command: (event) => {this.guardarGridEtapa();}, title:"Guarda Cambios" },
          { label: "", icon: "pi pi-refresh", command: (event) => { this.eventRefreschEmit.emit(this.consultaOrdenInput);  },  title:"Refrescar" },
        ];

        this.columnasTabla = [
           
            {field: "fecha",            header: "Fecha",         ordenar: false, style: "width: 75px;",},
            {field: "idEstatus",        header: "Estatus",       ordenar: false, style: "width: 80px;",},
            {field: "numOrden",         header: "Orden",         ordenar: false, style: "width: 70px;",},
            {field: "idDireccion",      header: "Área",          ordenar: false, style: "width: 130px;",},
            {field: "idDireccion1",     header: "Departamento",  ordenar: false, style: "width: 130px;",},
            {field: "idDireccion2",     header: "Oficina",       ordenar: false, style: "width: 130px;",},
            {field: "idUsuarioEjecuto", header: "Usuario",       ordenar: false, style: "width: 180px;",},
            {field: "observaciones",    header: "Observaciones", ordenar: false, style: "width: 190px;",},
        
          ];
          if(!this.esEstadoCuenta)this.columnasTabla.unshift(  {field: "operacion",        header: "",              ordenar: false, style: "width: 75px;",},);
      };
      
      ngOnChanges() {
        
    
        //this.cargaEtapasExistentes();
        
      };


      //incio de edicion tabla
      onEditInit(event){
        try {
          let etapasOdenesEdit = event.data

          this.etapasOdenesClone[etapasOdenesEdit.numRow] = { ...etapasOdenesEdit };
          etapasOdenesEdit.cambio = true;
          etapasOdenesEdit.baja = false;
    
          
        } catch (e) {
          this.muestraMensaje.error(e , "top", "center");
        }finally{
        
          console.log("paso por onEditInit")
        };
      };


      //evento al completar edicion tabla
      onEditComplete(event){
        try {
          let etapasOdenesEdit = event.data;

          // if(this.etapasOdenesClone[etapasOdenesEdit.numRow]){
          //   return
          // }

          if (
            etapasOdenesEdit.IdEstatus  === this.etapasOdenesClone[etapasOdenesEdit.numRow].IdEstatus &&
            etapasOdenesEdit.fecha       === this.etapasOdenesClone[etapasOdenesEdit.numRow].fecha &&
            etapasOdenesEdit.IdDireccion  === this.etapasOdenesClone[etapasOdenesEdit.numRow].IdDireccion &&
            etapasOdenesEdit.IdDireccion1 === this.etapasOdenesClone[etapasOdenesEdit.numRow].IdDireccion1 &&
            etapasOdenesEdit.IdDireccion2 === this.etapasOdenesClone[etapasOdenesEdit.numRow].IdDireccion2 &&
            etapasOdenesEdit.IdUsuarioEjecuto === this.etapasOdenesClone[etapasOdenesEdit.numRow].IdUsuarioEjecuto &&
            etapasOdenesEdit.observaciones === this.etapasOdenesClone[etapasOdenesEdit.numRow].observaciones
          ){
            let index = this.etapasOrdenesInput.findIndex((obj) => obj.numRow === etapasOdenesEdit.numRow);
            this.etapasOrdenes[index] = {...this.etapasOdenesClone[etapasOdenesEdit.numRow]};
            return;
          }

          etapasOdenesEdit.cambio = true;
          etapasOdenesEdit.baja = false;
          

        } catch (e) {
          this.muestraMensaje.error(e , "top", "center");
        }finally{
      
        };

      };

      //evento al cancelar la edicion tabla
      onEditCancel(event){
        try {
          let etapasOdenesEdit = event.data;
          let index = this.etapasOrdenes.findIndex(
          (obj) => obj.numRow === etapasOdenesEdit.numRow
         );
        this.etapasOrdenesInput[index] = { ...this.etapasOdenesClone[etapasOdenesEdit.numRow]};
        } catch (e) {
          this.muestraMensaje.error(e , "top", "center");
        }finally{
          console.log("paso por onEditCancel")
        };
      };

      //resibe flujo existente
      cargaEtapasExistentes(){
        //this.etapasOrdenes = [];
        this.etapasOdenesClone = [];

        if(this.etapasOrdenesInput?.length > 0 ){
          for (var i = 0, len = this.etapasOrdenesInput.length; i < len; ++i){
            
            this.etapasOrdenesInput[i].fecha != null?  this.etapasOrdenesInput[i].fecha =new Date(this.etapasOrdenesInput[i].fecha) : this.etapasOrdenesInput[i].fecha;
            //this.etapasOrdenes.push(this.etapasOrdenesInput[i])
            //this.etapasOdenesClone.push(this.etapasOrdenesInput[i])

          };
          
          this.etapasOdenesClone = this.etapasOrdenesInput;
        }
      }

      add(){

        try { 
          
          if(this.etapasOrdenesInput == undefined){
            throw new Error("Seleccione un registro primeramente.");
          }
          
          let registrosnew = this.etapasOrdenesInput.filter( x => x.id == 0);
          let etapasPendientes = this.etapasOrdenesInput.filter( x => [1,3,8].includes(x.IdEstatus));
          
          if(registrosnew.length >= 1){
            throw new Error("Solo es posible asginar una etapa a la vez.");
          }
          
          if(etapasPendientes.length >= 1){
            throw new Error("Existen etapas aun en proceso o vigente, no es posible agregar una nueva.");
          }

          const fechaActual = Date.now()
  
          let etapasOrdenesNuevo: any = {}
          etapasOrdenesNuevo.numRow = this.etapasOrdenesInput.length;
          etapasOrdenesNuevo.cambio = true;
          etapasOrdenesNuevo.baja = false;
          etapasOrdenesNuevo.IdDireccion  = 2;
          etapasOrdenesNuevo.numOrden = this.consultaOrdenInput.orden;
          etapasOrdenesNuevo.id = 0;
          etapasOrdenesNuevo.area = 'SIN ESTABLECER';
          etapasOrdenesNuevo.IdDireccion1 = 9;
          etapasOrdenesNuevo.departamento = 'SIN ESTABLECER';
          etapasOrdenesNuevo.IdDireccion2 = 46;
          etapasOrdenesNuevo.oficina = 'SIN ESTABLECER';
          etapasOrdenesNuevo.IdUsuarioEjecuto = null;
          etapasOrdenesNuevo.fecha = new Date(fechaActual);
          etapasOrdenesNuevo.observaciones = null;
          etapasOrdenesNuevo.IdUsuarioEjecuto = null;
          etapasOrdenesNuevo.usuario = null;
          etapasOrdenesNuevo.IdEstatus = 13;
          etapasOrdenesNuevo.estatusDesc = 'PENDIENTE';
          etapasOrdenesNuevo.id_concepto = 0;
        
          //agregamos nueva fila a tabla
          this.dtEtapasOrdenes.value.push(etapasOrdenesNuevo);
          this.dtEtapasOrdenes.initRowEdit(etapasOrdenesNuevo);
          this.dtEtapasOrdenes.sort;
          this.changeDetectorRef.detectChanges();
          
          
        } catch (e) {
          this.muestraMensaje.error( e, "top", "center");
        }
        
      };
      
      async catDireccionesGet(){
        try {
            const datoRetorno = await this.catDireccionesService.getAll().toPromise();

            this.catDireccionesAll = datoRetorno.map((datos)=> {return {label:datos.descripcion, value:datos.id, title: datos.idPadre?.toString()}})
            this.catDireccionesAll.unshift({ label: 'SELECCIONA...', value: null });

            this.CatDireccionesDto = datoRetorno.map((datos)=> {return {label:datos.descripcion, value:datos.id, title: datos.idPadre?.toString()}})
            this.CatDireccionesDto.unshift({ label: 'SELECCIONA...', value: null });

            this.CatDireccionesOfi = datoRetorno.map((datos)=> {return {label:datos.descripcion, value:datos.id, title: datos.idPadre?.toString()}})
            this.CatDireccionesOfi.unshift({ label: 'SELECCIONA...', value: null });

            this.catDireccionesAreas = datoRetorno.filter((datos) => [null].includes(datos.idPadre))
            .map((datos)=> {return {label:datos.descripcion, value:datos.id, title: datos.idPadre?.toString()}})

            this.catDireccionesAreas.unshift({ label: 'SELECCIONA...', value: null });


        } catch (e) {
          this.messageService.add({key:'mensaje', severity: 'error', detail: e.message + "( al pasar por ngOnInit)" });
        };
      };

      async getcatEstatus(){
        try {
          const datoRetorno = await this.catEstatusService.getAll().toPromise();
          this.estatus = datoRetorno.filter((datos) => [1,3,4,5,8,11].includes(datos.id)).map((datos) => {return {label:datos.descripcion, value: datos.id}})
          //this.estatus = datoRetorno.map((datos) => { return { label: datos.descripcion, value: datos.id }; });
          this.estatus.unshift({ label: 'SELECCIONA...', value: null });
        } catch (e) {
          this.messageService.add({ key: 'mensaje', severity: 'error', detail: e.message + " (catEstatusAll)" });
        };
      };

      async getcatEstatusFiltrado(){
        try {
          const datoRetorno = await this.catEstatusService.getAll().toPromise();
          this.estatusFiltrado = datoRetorno.filter((datos) => [13,14,4].includes(datos.id)).map((datos) => {return {label:datos.descripcion, value: datos.id}})
          //this.estatus = datoRetorno.map((datos) => { return { label: datos.descripcion, value: datos.id }; });
          this.estatusFiltrado.unshift({ label: 'SELECCIONA...', value: null });
        } catch (e) {
          this.messageService.add({ key: 'mensaje', severity: 'error', detail: e.message + " (catEstatusAll)" });
        };
      };



      async getAllCatUsuarios() {
        try {
          const datoRetorno = await this.catUsuariosService.getAll().toPromise();
          this.catUsuarios = datoRetorno.map((datos)=>{return { label: datos.nombre + ' ' + datos.primerApellido, value: datos.id, cuadrilla: datos.cuadrilla }});
          this.catUsuarios.unshift({ label: 'SELECCIONA...', value: null });
        } catch (e) {
          this.messageService.add({ key: 'mensaje', severity: 'error', detail: e.message + " (getAllCatUsuarios)" });
        } 
      };

      onAreaSelec(renglon: any, event: any){
        let selectedOption: any = {};
        selectedOption = this.catDireccionesAreas.find(opcion => opcion.value === event.value);
        renglon.area = selectedOption ? selectedOption.label: '';

        this.CatDireccionesDto = [];
        this.CatDireccionesDto  = this.catDireccionesAll.filter((datos => datos.title == event.value)) 
        this.CatDireccionesDto.unshift({ label: 'SELECCIONA...', value: null });

      };

      onDetpSelec(renglon: any, event: any){
        let selectedOption: any = {};
        selectedOption = this.CatDireccionesDto.find(opcion => opcion.value === event.value);
        renglon.departamento = selectedOption ? selectedOption.label: '';

        this.CatDireccionesOfi = [];
        this.CatDireccionesOfi = this.catDireccionesAll.filter((datos => datos.title == event.value)) 
        this.CatDireccionesOfi.unshift({ label: 'SELECCIONA...', value: null });

      };

      onOficinaSelec(renglon: any, event: any){
        let selectedOption: any = {};
        selectedOption = this.CatDireccionesOfi.find(opcion => opcion.value === event.value);
        renglon.oficina = selectedOption ? selectedOption.label: '';

      };

      onUsuarioSelec(renglon: any, event: any){
        let selectedOption: any = {};
        selectedOption = this.catUsuarios.find(opcion => opcion.value === event.value || opcion.cuadrilla === event.value);
        renglon.usuario = selectedOption ? selectedOption.label: '';
      };

      onEstatusSelec(renglon: any, event: any){
        let selectedOption: any = {};
        selectedOption = this.estatusFiltrado.find(opcion => opcion.value === event.value);
        renglon.estatusDesc = selectedOption ? selectedOption.label: '';
      };

      guardarGridEtapa(){
        try {
          
        } catch (error) {
          
        }
      } 
};
